module.exports = __webpack_public_path__ + "img/14117.9044c37e.png";